import React from 'react';

function SuccessView({ sharePointUrl, resetForm }) {
    // URL fija a la carpeta de SharePoint
    const folderUrl = "https://maccresi.sharepoint.com/sites/DAssetMgmt/Private/Forms/AllItems.aspx?id=%2Fsites%2FDAssetMgmt%2FPrivate%2FAlquizen%2FDocumentacion&viewid=157d4bf9%2D85c5%2D4862%2D8263%2D0a5b5b0b9404";

    return (
        <div className="text-center">
            <div className="text-success display-1 mb-3">✓</div>
            <h4 className="mb-3">¡Documentos Procesados Correctamente!</h4>
            <p className="text-muted mb-4">
                Los documentos han sido procesados y están disponibles en SharePoint.
            </p>

            <div className="d-grid gap-3">
                <a
                    href={folderUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                >
                    Abrir Carpeta en SharePoint
                </a>

                <button
                    onClick={resetForm}
                    className="btn btn-outline-secondary"
                >
                    Realizar Otra Petición
                </button>
            </div>
        </div>
    );
}

export default SuccessView;